import {Component, inject} from '@angular/core';
import {NgOptimizedImage} from '@angular/common';
import {AdobeCcAppsComponent} from './adobe-cc-apps/adobe-cc-apps.component';
import {
  AdobeCcInfoInstructionsComponent
} from './adobe-cc-info-instructions/adobe-cc-info-instructions.component';
import {
  AdobeSharedAupComponent
} from '../adobe-shared-aup/adobe-shared-aup.component';
import {
  AdobeSharedCreativeCampusBlurbComponent
} from '../adobe-shared-creative-campus-blurb/adobe-shared-creative-campus-blurb.component';
import {RouterLink} from '@angular/router';
import {
  ThirdPartyLicenseService
} from '../../third-party-license/third-party-license.service';
import {
  ThirdPartyLicenseOfferingService
} from '../../third-party-license-offering/third-party-license-offering.service';
import {
  ThirdPartyLicenseManagementService
} from '../../third-party-license-management/third-party-license-management.service';
import {UserService} from '@uofu-uss-aux/software-catalog-ng-core';
import {combineLatestWith, map, switchMap} from 'rxjs/operators';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-adobe-cc-landing',
  standalone: true,
  imports: [
    AdobeCcAppsComponent,
    AdobeCcInfoInstructionsComponent,
    NgOptimizedImage,
    AdobeSharedAupComponent,
    AdobeSharedCreativeCampusBlurbComponent,
    RouterLink,
  ],
  templateUrl: './adobe-cc-landing.component.html',
  styleUrl: './adobe-cc-landing.component.scss'
})
export class AdobeCcLandingComponent {
  private readonly thirdPartyLicenseService = inject(ThirdPartyLicenseService);
  private readonly thirdPartyLicenseOfferingService = inject(ThirdPartyLicenseOfferingService);
  private readonly thirdPartyLicenseManagementService = inject(ThirdPartyLicenseManagementService);
  private readonly userService = inject(UserService);

  private readonly adobeCCLicenseId$ =
    this.thirdPartyLicenseService.search('adobe', 'creative cloud')
      .pipe(
        map(page => page.data[0].id),
      );

  private readonly offeringId$ = this.adobeCCLicenseId$
    .pipe(
      combineLatestWith(this.userService.fetchLoggedInUser()),
      switchMap(([licenseId, user]) => this.thirdPartyLicenseOfferingService.search(licenseId, user.unid)),
      map(page => page.data[0].id),
    );

  private readonly isLicenseActive$ = this.offeringId$
    .pipe(
      combineLatestWith(this.userService.fetchLoggedInUser()),
      switchMap(([licenseId, user]) => this.thirdPartyLicenseManagementService.isLatestActive(licenseId, user.unid.replace('u', '0'))),
    );

  readonly isLicenseActive = toSignal(this.isLicenseActive$, {initialValue: false});
}
